import React from 'react';
import { Modal } from 'react-bootstrap';
import ChatBlue from '../../../assets/icon/Chat_blue.png';
import ChatGrey from '../../../assets/icon/Chat_grey.png';

export default function ChatInfoModal({ showModal, setShowModal }) {
    return (
        <Modal className="auth-popup" show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body >
                <div className="padding-x p-3">
                    <div className="chat-info-inner text-center">
                        <div className='chat-info-img'>
                        <img src={ChatGrey} />
                        <img src={ChatBlue} />
                        </div>
                        <h3>If you the leave the page the chat will turn off automatically!</h3>
                        <button className='gred-btn w-80 mt-4 px-5' onClick={() => setShowModal(false)}>
                            Ok
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}